/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditVideoNoteAction.REQUEST_EDITVIDEONOTE:
      return {
        ...state,
    };
    case actions.EditVideoNoteAction.EDITVIDEONOTE_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
